<template>
    <base-dialog ref="base">
        <v-card tile>
            <v-toolbar flat class="flex-grow-0">
                <v-toolbar-title class="pl-3">Выгрузка закупки</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn
                        icon
                        @click="$refs.base.hide()"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card-text class="pt-4">
                <v-row no-gutters justify="center" align="center" style="height: 240px">
                    <v-col cols="auto" class="text-center">
                        <v-progress-circular
                            indeterminate
                            size="90"
                            width="3"
                            color="dark"
                        />
                        <div class="mt-12 primary--text">
                            Подготавливаем файл для скачивания.<br/>
                            Пожалуйста, подождите...
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </base-dialog>
</template>

<script>
import BaseDialog from "@/components/utils/BaseDialog.vue";
import EventBus from "@/event-bus";
import purchaseService from "@/services/purchaseService";
import fileService from "@/services/fileService";

export default {
    name: "DownloadPurchaseDialog",
    components: {BaseDialog},
    data() {
        return {
            interval: undefined,
            purchase_id: undefined,
        }
    },
    methods: {
        waitFile(file_id) {
            const vm = this;
            vm.interval = setInterval(async () => {
                const file = await fileService.getFile(file_id);
                if (file.file !== null) {
                    clearInterval(vm.interval);
                    const url = file.file;
                    const link = document.createElement('a');
                    link.href = url;
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    if (vm.$refs.base !== undefined) {
                        vm.$refs.base.hide();
                    }
                }
            }, 5000);
        },
        async downloadPurchase() {
            const response = await purchaseService.downloadPurchase(this.purchase_id);
            const file = await fileService.getFile(response.file_id);
            if (file.file === null) {
                this.waitFile(file.id);
            }
        }
    },
    beforeDestroy() {
        if (this.interval !== undefined)
            clearInterval(this.interval);
    },
    created() {
        const vm = this;
        EventBus.$on('download_purchase_dialog', function (purchase_id) {
            vm.purchase_id = purchase_id;
            vm.downloadPurchase();
            if (vm.$refs.base !== undefined) {
                vm.$refs.base.show();
            }
        })
    }
}
</script>

<style scoped>

</style>